export default __webpack_public_path__ + "static/media/staff_detail_location.2a2f3deb.svg";